import React from 'react';
import { FiFileText } from 'react-icons/fi';
import TabSectionHeader from '../Elements/TabSectionHeader';
import CompanyLink from '../Elements/CompanyLink';
import ProfileLink from '../Elements/ProfileLinks';
import { GITHUB_LINK, LINKED_IN_LINK, RESUME_LINK } from '../utils/constants';

import profilePhoto from '../assets/Images/profile.jpg';
import paxcomLogo from '../assets/Images/paxcom-logo.png';
import integolfLogo from '../assets/Images/integolf-logo.png';
const ABOUT_HIGHLIGHTS = [
  'Associate Technical Lead at Paxcom India (Paymentus) since 2019 — leading full-stack delivery for eCommerce and data-intensive platforms.',
  'MERN & platform engineering — React, Node.js, MongoDB, with Kafka pipelines and Kubernetes deployments in production.',
  'Domain experience across hospitality, booking, inventory, and high-volume file ingestion workflows.',
  'Freelance technical architect — shipped products end-to-end (e.g. Integolf tee-time and tournament platforms).',
  'Team-oriented builder — mentoring developers and turning requirements into robust, maintainable systems.',
];

const INTEGOLF_HIGHLIGHT_INDEX = 3;

const CONTRACT_CALLOUT =
  'Open to contract engagements and technical collaborations.';

const AboutMe = () => {
  return (
    <section className="bg-transparent text-ink">
      <TabSectionHeader tabIndex={0} />

      <div className="mt-8 about-hero relative overflow-hidden rounded-xl">
        <img
          src={profilePhoto}
          alt="Ravinder Rikhi"
          className="w-full h-48 sm:h-52 object-cover object-top block md:h-auto md:object-contain"
        />
        <div
          className="about-hero-fade absolute inset-0 hidden md:block"
          aria-hidden="true"
        />

        <div className="relative p-4 max-w-full md:absolute md:inset-0 md:z-10 md:flex md:items-start">
          <div className="md:p-8 md:max-w-[50%]">
            <p className="text-base md:text-lg mb-4">
              I’m Ravinder, a Software Developer currently working as an associate
              technical lead at{' '}
              <a
                href="https://www.linkedin.com/company/paxcom-india/"
                target="_blank"
                rel="noreferrer"
                className="text-accent"
              >
                <img
                  src={paxcomLogo}
                  alt=""
                  aria-hidden="true"
                  className="inline h-4 w-4 shrink-0 rounded-sm object-contain align-[-2px]"
                />{' '}
                Paxcom India (P) Ltd - A Paymentus Company
              </a>{' '}
              with a passion for building robust, scalable & beautiful web products.
            </p>
            <p className="text-md mb-4">
              With over 6+ years of experience, I have developed applications that
              serve top of the line organisations. I specialize in creating efficient
              and scalable solutions using the latest web technologies.
            </p>

            <ul className="space-y-1.5 text-muted text-sm md:text-base">
              {ABOUT_HIGHLIGHTS.map((highlight, index) => (
                <li key={highlight} className="flex gap-2">
                  <span className="text-accent shrink-0" aria-hidden="true">
                    •
                  </span>
                  <span>
                    {index === INTEGOLF_HIGHLIGHT_INDEX ? (
                      <>
                        Freelance technical architect — shipped products end-to-end
                        (e.g.{' '}
                        <CompanyLink
                          href="https://www.integolf.com/"
                          icon={integolfLogo}
                        >
                          Integolf
                        </CompanyLink>{' '}
                        tee-time and tournament platforms).
                      </>
                    ) : (
                      highlight
                    )}
                  </span>
                </li>
              ))}
            </ul>

            <p className="text-muted italic text-sm mt-3">
              {CONTRACT_CALLOUT}
            </p>

            <div className="flex flex-col gap-3 items-start mt-6">
              <ProfileLink compact onClick={() => window.open(LINKED_IN_LINK, '_blank')}>
                <svg
                  className="h-4 w-4 text-muted shrink-0"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
                <span>Connect with me on LinkedIn</span>
              </ProfileLink>
              <ProfileLink compact onClick={() => window.open(RESUME_LINK, '_blank')}>
                <FiFileText className="h-4 w-4 text-muted shrink-0" aria-hidden="true" />
                <span>Check my resume</span>
              </ProfileLink>
              <ProfileLink compact onClick={() => window.open(GITHUB_LINK, '_blank')}>
                <svg
                  className="h-4 w-4 text-muted shrink-0"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22" />
                </svg>
                <span>Check some of my side-projects</span>
              </ProfileLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
